module.exports = __webpack_public_path__ + "static/media/30x30-9.e904e058.png";